export default "__VITE_ASSET__65a1aa06__"